import startChatProgram from './chatProgram'

const setApi = (api) => {
  return api.get('/virtual_portal/survey_user' ).then((response) => {
    const returnData = response.data.survey_user
    const user = returnData.user
    const event = returnData.event
    window.currentUser = user
    window.currentEvent = event
    let dataLayer = window.dataLayer = window.dataLayer || []
    dataLayer.push({
      event_id: event.id,
      event_name: event.event_name,
      event_type: event.event_type,
      brand: event.brand,
      region: event.region,
      crm_contact_id: user.crm_contact_id
    })
    window.__lc.params = [
      { name: 'Name', value: user.full_name },
      { name: 'CrmID', value: user.crm_contact_id },
      { name: 'EventName', value: event.event_name },
      { name: 'EventId', value: event.id }
    ]
    startChatProgram()
    if(window.LiveChatWidget) {
      window.LiveChatWidget.call('set_customer_name', user.full_name + ' (' + event.website_display_name + ') ' )
    }
    return({
      isRefreshing: false,
      hasValidToken: true,
      eventName: event.website_display_name,
      eventHasPeerToPeer: event.has_peer_to_peer,
      eventBeginDate: event.event_begin_date,
      peerToPeerWizardIsAvailable: event.peer_to_peer_wizard_is_available,
      eventBeginTime: event.event_ics_begin_time,
      eventEndTime: event.event_ics_end_time,
      eventTimeZone: event.timezone_abbreviation,
      emergencyBroadcastMessage: event.emergency_broadcast_message,
      isVirtualEvent: event.is_virtual_event,
      userRegistrationStatus: returnData.survey_user_status,
      userFullName: user.full_name,
      userPhoto: user.photo,
      userTitle: user.title,
      userOrganizationName: user.organization_name,
      userDetails: {
        status: user.status,
        crm_contact_id: user.crm_contact_id,
        sponsor_id: user.sponsor_id,
        lpsIsComplete: returnData.lps_is_complete,
        lpsSurveyLink: returnData.lps_survey_link,
        userHasPeerToPeer: returnData.has_1_on_1_platform_opt_in
      }
    })
  }).catch((e) => {
    return({
      hasValidToken: false,
      fetchingErrorMessage: e.message
    })
  })
}

export default setApi